import { DataconnectionCard } from '~src/app/spaces/CardView/DataconnectionCard';
import { Messages } from '~src/codegen/Localize';
import { DataConnections } from '~src/connectivity/resources/DataConnections';
import { ContentTypeFilterClause, MixedContentItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DataConnectionContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getDataConnectionDefaultFilters } from './getDefaultFilters';

export const DataConnectionDefinition: MixedContentItemDefinition = {
  itemType: 'dataconnection',
  pluralName: Messages.connections,
  singularName: Messages.connection,
  emptyStateMessage: Messages.connectionsEmptyMessage,
  siteFilterByTypeDropdownName: () => '', // connections can be viewed as mixed content, but not as top-level content
  contentFilterKeys: DataConnectionContentType.filterKeys,
  defaultFilters: getDataConnectionDefaultFilters,
  cardComponent: DataconnectionCard,
  listViewIconUrl: '', // we don't display an icon for data connections
  filterClause: ServerFilterClauses.ContentType(['dataconnection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return DataConnections.all();
  },
  fieldValueResourceType: 'dataConnection',
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for dataconnection');
  },
  supportedDisplayModes: ['list', 'thumbnail'],
};
